import styled, { css } from 'styled-components';

import { theme } from '../../constants/theme';

interface ISlickyCarouselStyles {
  slideHeight?: number;
  slideMarginRight?: number;
  prevButtonId?: string;
  nextButtonId?: string;
}

export const SliderContainer = styled.div<ISlickyCarouselStyles>`
  width: auto;

  & .slick-slide {
    height: ${({ slideHeight }) => (!!slideHeight ? `${slideHeight}px` : '250px')};
    margin-right: ${({ slideMarginRight }) => !!slideMarginRight && slideMarginRight + 'px'};
  }

  /* & #bannerAnterior {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    position: absolute;
    bottom: -60px;
    left: calc(50% - 41px);
  } */

  & #prevBanner,
  ${({ prevButtonId }) => prevButtonId && `#${prevButtonId}`} {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    position: absolute;
    bottom: -60px;
    left: calc(50% - 41px);
  }

  & #nextBanner,
  ${({ nextButtonId }) => nextButtonId && `#${nextButtonId}`} {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    position: absolute;
    bottom: -60px;
    left: calc(50%);
  }
`;

export const SlickyCarouselButton = styled.button`
  display: flex;
  outline: none;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  width: 41px;
  height: 40px;
  border-radius: 8px;
  background: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.secondary.gray400};
  cursor: pointer;

  &:hover {
    background: ${theme.colors.secondary.gray500};
    transition: background 150ms ease-in-out;
  }
`;
